module.exports = "https://web-assets-production.autolist.com/_next/static/images/fort-wayne-in-4f7b8838d4339cc922cd983970aa1acc.jpg";